<template>
  <div>
    <p class="mb-5">{{ 'employees.form.new-personal-description' | translate }}</p>

    <form-input-container :title="'Naam Werknemer'">
      <div class='hf fl '>
        <text-field v-model="initials" :errors="validationResult.messagesFor('initials')"
          :label="'employee.initials' | translate" style='max-width: 150px;' class='mr-4' />

        <text-field v-model="middleName" :label="'employee.last-name-prefixes' | translate" optional class='mr-4' />

        <text-field v-model="lastName" :errors="validationResult.messagesFor('lastName')"
          :label="'employee.last-name' | translate" />
      </div>
    </form-input-container>

    <form-input-container title='Geboortenaam' text='Is de werknemer gehuwd? Geef dan de geboortnaam op.'>
      <div class='fl hf'>
        <text-field optional v-model="middleNamePartner" :label="'employee.last-name-partner-prefixes' | translate" class='mr-4' />
        <text-field optional v-model="lastNamePartner" :label="'employee.last-name-partner' | translate" />
      </div>
    </form-input-container>

    <form-input-container title='Aanvullende Gegevens' text='Vul de aanvullende gegevens in.'>
      <div class='fl hf'>
        <gender-switch class='mr-4' :label="'employee.gender' | translate" :errors="validationResult.messagesFor('gender')"
          :gender="gender" :onMaleSelect="() => gender = 'Male'" :onFemaleSelect="() => gender = 'Female'"/>

        <date-picker v-model="dateOfBirth" :errors="validationResult.messagesFor('dateOfBirth')"
          :label="'employee.date-of-birth' | translate" style='width: 400px' class='mr-4' min='1940-01-01' :max="new Date().toISOString()"/>
        <date-picker v-model="dateOfDeath" :errors="validationResult.messagesFor('dateOfDeath')" :min="dateOfBirth" :max="new Date().toISOString()"
          :label="'employee.date-of-death' | translate" optional right style='width: 400px' clearable />
      </div>
    </form-input-container>

    <div style="float: right" class='mt-5'>
      <Button primary   @click="this.handleCancelClick" class="mr-3">{{ 'buttons.cancel' | translate }}</Button>
      <Button secondary @click="this.handleContinueClick" :disabled="!(validationResult.isValid() && requiredFields.isValid())">
        {{ 'buttons.next-step' | translate }}
      </Button>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

import Helpers from '@/shared/helpers/functions';
import NewEmployee from '@/views/constants/employee-new';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';
import GenderSwitch from '@aevitae/aevitaeui/1_molecules/buttons/GenderSwitch.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


export default {
  name: 'NewEmployeePersonal',
  components: {
    Button,
    TextField,
    FormInputContainer,
    GenderSwitch,
    DatePicker
  },

  methods: {
    dispatchChange (attribute, value) {
      this.$store.dispatch(
        NewEmployee.Actions.Form.EMPLOYEE_CHANGE, {
          attribute: attribute,
          value: value
        }
      ).then(this.$store.dispatch(NewEmployee.Actions.Steps.Completed.UPDATE));
    },

    handleContinueClick () {
      this.$store.dispatch(NewEmployee.Actions.Navigate.DO, NewEmployee.Views.Employment);
    },
    handleCancelClick () {
      this.$store.dispatch(NewEmployee.Actions.Cancel.DO);
    }
  },

  computed: {
    ...mapGetters({
      newEmployee: 'newEmployee',
      newEmployeeRelationship: 'newEmployeeEmploymentRelationship',

      validationResult: 'newEmployeeValidations',
      requiredFields: 'newEmployeeRequiredFields'
    }),

    initials: {
      get () { return this.newEmployee.initials; },
      set (v) { this.dispatchChange('initials', v); }
    },
    middleName: {
      get () { return this.newEmployee.middleName; },
      set (v) { this.dispatchChange('middleName', v); }
    },
    lastName: {
      get () { return this.newEmployee.lastName; },
      set (v) { this.dispatchChange('lastName', v); }
    },

    lastNamePartner: {
      get () { return this.newEmployee.lastNamePartner; },
      set (v) { this.dispatchChange('lastNamePartner', v); }
    },
    middleNamePartner: {
      get () { return this.newEmployee.middleNamePartner; },
      set (v) { this.dispatchChange('middleNamePartner', v); }
    },

    dateOfBirth: {
      get () { return this.newEmployee.dateOfBirth; },
      set (v) { this.dispatchChange('dateOfBirth', v); }
    },
    formattedDateOfBirth () {
      return Helpers.Dates.formatDate(this.dateOfBirth);
    },

    dateOfDeath: {
      get () { return this.newEmployee.dateOfDeath; },
      set (v) {
        this.dispatchChange('dateOfDeath', v);
        this.$store.dispatch(NewEmployee.Actions.Form.RELATIONSHIP_CHANGE, { attribute: 'untilDate', value: v });
      }
    },
    formattedDateOfDeath () {
      return Helpers.Dates.formatDate(this.dateOfDeath);
    },

    gender: {
      get () { return this.newEmployee.gender; },
      set (v) { this.dispatchChange('gender', v); }
    }
  }
};
</script>

<style lang='scss' scoped>
table {
  border-collapse: seperate;
}

p {
  font-size: 1em;
}
</style>
